import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { ValuePropsSection } from '../components/ValuePropsSection';
import { ServicesSection } from '../components/ServicesSection';
import { WhyChooseUsSection } from '../components/WhyChooseUsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { ServiceAreaSection } from '../components/ServiceAreaSection';
import { CTABannerSection } from '../components/CTABannerSection';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="w-full min-h-screen" style={{
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-290">
      <Navbar data-id="element-291" />
      <main data-id="element-292">
        <HeroSection data-id="element-293" />
        <ValuePropsSection data-id="element-294" />
        <ServicesSection data-id="element-295" />
        <WhyChooseUsSection data-id="element-296" />
        <TestimonialsSection data-id="element-297" />
        <PricingSection data-id="element-298" />
        <ServiceAreaSection data-id="element-299" />
        <CTABannerSection data-id="element-300" />
      </main>
      <Footer data-id="element-301" />
    </div>;
}